// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"8e1c03af","189":"111c0551","372":"3d0f0039","453":"405e9548","624":"5130ab4e","876":"98134b18","884":"77b3f7c7"}[chunkId] + ".chunk.js";
};